import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchStats = async () => {
  const { data } = await axios.get(`${API}/stats`);
  return data;
};

export const sendContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};

// --- TIRERA Construction & Habitat (public) ---
export const submitQuote = (p) => axios.post(`${API}/construction/quotes`, p).then((r) => r.data);
export const registerArtisan = (p) => axios.post(`${API}/construction/artisans`, p).then((r) => r.data);
export const fetchArtisans = (trade) =>
  axios.get(`${API}/construction/artisans`, { params: trade ? { trade } : {} }).then((r) => r.data);
export const requestArtisan = (id, p) =>
  axios.post(`${API}/construction/artisans/${id}/requests`, p).then((r) => r.data);
export const rateArtisan = (id, p) =>
  axios.post(`${API}/construction/artisans/${id}/ratings`, p).then((r) => r.data);
export const orderMaterial = (p) => axios.post(`${API}/construction/material-orders`, p).then((r) => r.data);
export const reportIssue = (p) => axios.post(`${API}/construction/issues`, p).then((r) => r.data);

// Biens immobiliers publiés (catalogue public)
export const fetchPublicProperties = () =>
  axios.get(`${API}/construction/properties/public`).then((r) => r.data);
export const photoUrl = (path) => (path && /^https?:\/\//i.test(path) ? path : `${API}/construction/photo/${path}`);

// --- Réalisations (portfolio) ---
export const fetchRealizations = (category) =>
  axios.get(`${API}/construction/realizations`, { params: category && category !== "all" ? { category } : {} }).then((r) => r.data);
export const fetchFeaturedRealizations = () =>
  axios.get(`${API}/construction/realizations/featured`).then((r) => r.data);
export const fetchRealization = (id) =>
  axios.get(`${API}/construction/realizations/${id}`).then((r) => r.data);
